import { render } from "./updateOfferStatus.vue?vue&type=template&id=3261f29c"
import script from "./updateOfferStatus.vue?vue&type=script&lang=js"
export * from "./updateOfferStatus.vue?vue&type=script&lang=js"
script.render = render

export default script